import useTracking from "../../common/tracking/ninja/useTracking";
import MobileSearchTrigger from "./MobileSearchTrigger";
import Overlay from "./Overlay";
import Search from "./Search";
import React, { useState } from "react";
export default function MobileSearchWrapper() {
    const [open, setOpen] = useState(false);
    const { trackEvent } = useTracking();
    return (<>
      <MobileSearchTrigger onOpen={() => { setOpen(true); trackEvent("search_text_start"); }}/>
      <Overlay open={open} onClose={() => setOpen(false)}>
        {open && <Search onClose={() => setOpen(false)}/>}
      </Overlay>
    </>);
}
